import { createRouter, createWebHashHistory } from "vue-router";
import login from "@/components/login.vue";
import Dashboard from "@/components/dashboard.vue";
import adminpanel from "@/components/adminpanel.vue";
import { useAuth } from "@/composable";

const routes = [
  {
    path: "/",
    name: "login",
    component: login,
    meta: { requiresGuest: true }, // Redirect authenticated users away from login
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin",
    name: "admin",
    component: adminpanel,
    meta: { requiresAuth: true },
  },
  {
    // Catch-all route for 404s
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    const { waitForAuthInit, isAuthenticated, isAdmin } = useAuth();

    // Wait for auth to be initialized
    await waitForAuthInit();

    // Handle guest-only routes (like login page)
    if (to.meta.requiresGuest && isAuthenticated.value) {
      return next("/dashboard");
    }

    // Handle protected routes
    if (to.meta.requiresAuth && !isAuthenticated.value) {
      return next("/");
    }

    // Handle admin-only routes
    if (to.meta.requiresAdmin && (!isAuthenticated.value || !isAdmin.value)) {
      return next("/dashboard");
    }

    next();
  } catch (error) {
    console.error("Router guard error:", error);
    // On auth error, redirect to login
    next("/");
  }
});

export default router;
